/* -----------------------------------------------------------------------
 * <copyright company="Microsoft Corporation">
 *   Copyright (c) Microsoft Corporation.  All rights reserved.
 * </copyright>
 * ----------------------------------------------------------------------- */

import React from "react";
import { useWindowWidth } from "../util";

export const ExpiryIcon: React.FC = () => {
  const [iconSize, setIconSize] = React.useState({
    width: "",
    height: "",
    viewWidth: "",
    viewHeight: "",
  });

  const view = useWindowWidth();

  React.useEffect(() => {
    if (view.width >= 537) {
      setIconSize({
        width: "211",
        height: "180",
        viewWidth: "0",
        viewHeight: "0",
      });
    } else if(view.width >= 378) {
      setIconSize({
        width: "180",
        height: "149",
        viewWidth: "0",
        viewHeight: "0",
      });
    }
      else{
      setIconSize({
        width: "149",
        height: "120",
        viewWidth: "0",
        viewHeight: "20",
      });
    }
  }, [view.width]);

  const GetResponsiveIcon = (width: string, height: string, viewWidth: string, viewHeight: string) => {
    return (
      <svg
        width={width}
        height={height}
        viewBox={`${viewWidth} ${viewHeight} 211 180`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0)">
          <path
            d="M98.2414 90.5181C79.6207 94.3457 61 98.1733 42.4828 101.897C40.931 102.208 39.4828 101.38 38.8621 99.9319C34.2069 87.4146 31.2069 62.2767 31 43.4491C31 41.8974 32.0345 40.5526 33.5862 40.3457C51.069 36.9319 68.6552 33.5181 86.2414 30.1043C88.1035 29.6905 89.8621 31.1388 89.9655 33.0008C91.1035 54.0008 92.3448 69.5181 100.414 86.0698C101.345 87.9319 100.31 90.1043 98.2414 90.5181Z"
            fill="#7BDDEF"
          />
          <path
            d="M156.586 125.277C132.793 134.484 103.207 141.518 79.207 149.898C77.8621 150.415 76.3104 149.898 75.4828 148.553C61.9311 126.208 56.2414 78.9322 55.1035 67.2425C54.8966 65.6908 55.9311 64.346 57.3794 63.9322L134.035 42.5184C135.897 42.0012 137.759 43.2425 137.966 45.1046C139.414 57.208 145 96.8287 158.241 120.829C159.069 122.484 158.345 124.553 156.586 125.277Z"
            fill="url(#paint0_radial)"
          />
          <path
            d="M127.724 81.2065L80.8618 94.0341C78.5859 94.6548 76.2066 93.31 75.5859 91.0341C74.9652 88.7582 76.3101 86.3789 78.5859 85.7582L125.448 72.9307C127.724 72.31 130.103 73.6548 130.724 75.9307C131.345 78.2065 130 80.5858 127.724 81.2065Z"
            fill="white"
          />
          <path
            d="M112.207 106.035L86.2417 113.276C83.9658 113.897 81.5865 112.552 80.9658 110.276C80.3451 108 81.6899 105.621 83.9658 105L109.931 97.7588C112.207 97.1381 114.587 98.4829 115.207 100.759C115.828 103.035 114.483 105.414 112.207 106.035Z"
            fill="white"
          />
          <path
            d="M150.46 84.9851L112.614 123.354C110.371 125.591 111.715 129.29 115.021 130.011L171.153 141.703C174.467 142.374 177.232 139.56 176.168 136.602L157.882 86.5419C156.818 83.5841 152.703 82.7482 150.46 84.9851Z"
            fill="#FFD590"
          />
          <path
            d="M146.578 120.015C145.406 119.748 144.622 118.684 144.884 117.619L149.304 97.7501C149.566 96.6847 150.709 95.9953 151.88 96.2622C153.052 96.5291 153.836 97.5927 153.574 98.6581L149.154 118.527C148.892 119.592 147.756 120.232 146.578 120.015Z"
            fill="white"
          />
          <path
            d="M145.275 126.846C146.615 127.037 147.841 126.201 148.015 124.981C148.189 123.76 147.244 122.616 145.904 122.425C144.564 122.235 143.338 123.07 143.164 124.291C142.99 125.511 143.936 126.656 145.275 126.846Z"
            fill="white"
          />
        </g>
        <defs>
          <radialGradient
            id="paint0_radial"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(138.486 148.918) scale(52.7553)"
          >
            <stop offset="0.00065331" stopColor="#3E8EED" />
            <stop offset="1" stopColor="#72ACF1" />
          </radialGradient>
          <clipPath id="clip0">
            <rect
              width="148.655"
              height="120"
              fill="white"
              transform="translate(31 30)"
            />
          </clipPath>
        </defs>
      </svg>
    );
  };
  const iconElement =
    iconSize.width === ""
      ? null
      : GetResponsiveIcon(iconSize.width, iconSize.height, iconSize.viewWidth, iconSize.viewHeight);
  return iconElement;
};
